import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import invariant from 'invariant'; // NOTE: custom memoization until we need to pull in a util lib like lodash
// for other reasons!

var memoizeCache = [];
export function mapStateToProps(namespace, state, ownProps) {
  var currState = state[namespace];
  invariant(currState, "You defined an invalid namespace. No state found for '".concat(namespace, "'!"));
  var findCache = memoizeCache.find(function (c) {
    return c.key === currState;
  });

  if (findCache) {
    return findCache.value;
  }

  var mapState = _defineProperty({}, namespace, _objectSpread({}, currState.locations[currState.current], {
    history: currState.history.map(function (id) {
      return currState.locations[id];
    })
  }));

  memoizeCache.push({
    key: currState,
    value: mapState
  });
  return mapState;
}